import { useEffect, useState, useRef } from 'react';

export default function SensorWebSocket({ sensorId, onMessages }) {
    const wsRef = useRef(null);
    const pendingMessages = useRef([]);

    useEffect(() => {
        if (!sensorId) return;

        if (!wsRef.current) {
            wsRef.current = new WebSocket(process.env.REACT_APP_WEBSOCKET);

            wsRef.current.onopen = () => {
                console.log('WebSocket connected');
                pendingMessages.current.forEach(msg => wsRef.current.send(msg));
                pendingMessages.current = [];
                wsRef.current.send(JSON.stringify({ type: 'subscribe', sensorId }));
            };

            wsRef.current.onmessage = (event) => {
                const msg = JSON.parse(event.data);
                if (msg.sensorId === sensorId) {
                    onMessages(msg); // callback to parent component
                }
            };

            wsRef.current.onclose = () => {
                console.log('WebSocket closed');
                wsRef.current = null;
            };
        }

        const send = (msgObj) => {
            const msg = JSON.stringify(msgObj);
            if (wsRef.current && wsRef.current.readyState === WebSocket.OPEN) {
                wsRef.current.send(msg);
            } else {
                pendingMessages.current.push(msg);
            }
        };

        return () => {
            // Clean up on unmount
            if (wsRef.current && wsRef.current.readyState === WebSocket.OPEN) {
                wsRef.current.send(JSON.stringify({ type: 'unsubscribe', sensorId }));
                wsRef.current.close();
            }
        };
    }, [sensorId]);

    return null;
}
